module.exports = __webpack_public_path__ + "lesotho.svg?c23abb8216be0ac49591f63aaecc6107";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/lesotho.svg
// module id = 212
// module chunks = 10